import styled from 'styled-components'
import Card from '../../juegos/card.jsx'
import { useState,useEffect } from 'react'



const Container=styled.div`

	display:flex;
	justify-content:center;
	align-items:center;
	height:230px;
	width:220px;
	
	

  `;

const ContainerCard=styled.div` 
	height :230px;
	width:220px;
`;

export default function PreviewCard(props){
	let { juego }=props;
	let [poster,setPoster]=useState(juego);

	useEffect(()=>{ setPoster(juego)},[juego])
	

	return(
		<Container>
			<ContainerCard><Card  consola={poster.consola} poster={poster.poster}  /></ContainerCard>
			
		</Container>)
}